import React, { useRef, useState } from 'react';
import debounce from 'debounce';

import Grid from '@material-ui/core/Grid'

// import CityPicker from '../../booking/location/CityPicker';
import InputAdornment from '@material-ui/core/InputAdornment';
import PostCodeInput from '../../../app/common/ui/locations/PostCodeInput';
import TextField from '@material-ui/core/TextField'

const MemberLocation = ({ value, onChange }) => {
    const [location, setLocation] = useState(value || {});
    const distanceRef = useRef()

    const applyChange = state => {
        setLocation(state);
        onChange({ location: state });
    }

    const handleChange = debounce(fragment => {
        applyChange({ ...location, ...fragment });

    }, 500);

    const handlePostCodeChange = place => {
        const updated = {
            ...location,
            city:  {
                geo: {
                    longitude: place.longitude,
                    latitude: place.latitude
                },
                postcode: place.postcode,
                name: `${place.admin_ward}, ${place.admin_district}, ${place.region}`
            }
        };

        // console.log('handlePostCodeChange', updated);
        applyChange(updated);
    }


    return (<React.Fragment>
        <Grid container spacing={2}>
            <Grid item xs={3}>
                <PostCodeInput postcode={location?.city?.postcode} description={location?.city?.name} label="Your home postcode" onChange={handlePostCodeChange} />
                {/* <CityPicker address={location.city?.name} onChange={city => handleChange({ city })} label="Where do you live" /> */}
            </Grid>
            <Grid item xs={3}>
                <TextField
                    inputRef={distanceRef}
                    label="How far would you travel"
                    helperText="For anywhere just enter a big number!"
                    defaultValue={location.maxTravelDistance || 50}
                    type="number"
                    variant="outlined"
                    onChange={() => handleChange({ maxTravelDistance: distanceRef.current.value })}
                    InputProps={{
                        endAdornment: <InputAdornment>&nbsp;miles</InputAdornment>,
                    }}
                />
            </Grid>
        </Grid>
    </React.Fragment>);
};

export default MemberLocation;